export const downloadFile = (url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "");
  document.body.appendChild(link);
  link.target = "_blank";
  link.click();
  document.body.removeChild(link);
};
